import { IFormField, IFormSection } from "../../../../../shared/components/web-form/web-form.objects";
import _ from "lodash";

export class ExternalColabField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;

    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    controllingDropdownSelector: string;
    showWhenValue: string;
    blockSelector: string;

    constructor(
        propertyName: string,
        defaultVal: any,
        fieldId: string,
        displayName: string,
        isRequired: boolean,
        controllingDropdownSelector: string,
        showWhenValue: string,
        blockSelector: string
    ) {
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.controllingDropdownSelector = controllingDropdownSelector;
        this.showWhenValue = showWhenValue;
        this.blockSelector = blockSelector;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;
        this.initializeSectionUpdateTrigger();
        this.toggleTextbox();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("keyup change", () => {
            const isValid = this.checkValid();
            this.displayValid(isValid);
            this.triggerSectionUpdate();
        });

        $(this.controllingDropdownSelector).on("changed.bs.select change", () => {
            this.toggleTextbox();
            this.triggerSectionUpdate();
        });
    }

    private toggleTextbox() {
        const dropdownVal = String($(this.controllingDropdownSelector).val());

        if (dropdownVal === this.showWhenValue) {
            $(this.blockSelector).removeClass("d-none");
        } else {
            $(this.blockSelector).addClass("d-none");
            $(`#${this.fieldId}`).val("");
            this.resetValidDisplay();
        }
    }

    private getInput(): string {
        return ((<string>$(`#${this.fieldId}`).val()) || "").trim();
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();

        if (isValid && isChanged) {
            val = this.getInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            $(`#${this.fieldId}`).val(formVal);
        }
    }

    checkValid(): boolean {
        const dropdownVal = String($(this.controllingDropdownSelector).val());

        if (dropdownVal !== this.showWhenValue) {
            return true;
        }

        const val = this.getInput();
        const words = val.split(/\s+/).filter(Boolean);
        const wordCount = val === "" ? 0 : words.length;

        return wordCount <= 100;
    }

    checkChanged(): boolean {
        let val = this.getInput();
        return val != this.defaultVal;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}